import type { FC } from 'react'
import type { NutrientPerServing } from 'types/gql/type-defs'

import { formatNumericValue } from 'utils/number'
import { formatProductQuantityUnit } from 'utils/products/product-quantity-unit'

import { NutrientInfoTable } from './NutrientInfoTable'

const TABLE_HEADERS = [
  {
    index: 1,
    headerI18nKey: 'Nutrition declaration',
  },
  {
    index: 2,
    headerI18nKey: 'Per portion',
  },
]

const renderNutrientPerServingInfo = (
  nutrient: Pick<NutrientPerServing, 'name' | 'value' | 'unit'>,
  index: number,
) => (
  <div className="tableRow" key={index}>
    <div className="cell">{nutrient.name}</div>
    <div className="cell">
      {`${formatNumericValue(nutrient.value || 0)}
      ${formatProductQuantityUnit(nutrient.unit)}`}
    </div>
  </div>
)

interface NutrientsPerServingInfoTableProps {
  nutrients: Pick<NutrientPerServing, 'name' | 'value' | 'unit'>[]
}

export const NutrientsPerServingInfoTable: FC<NutrientsPerServingInfoTableProps> = ({
  nutrients,
}) => {
  return (
    <NutrientInfoTable headers={TABLE_HEADERS}>
      {nutrients.map((nutrient, index) => renderNutrientPerServingInfo(nutrient, index))}
    </NutrientInfoTable>
  )
}
